import React from 'react'
import DataCard from "./DataCard"
import graphb from "../images/graphb.png"
import graphy from "../images/graphy.png"
import graphp from "../images/graphp.png"
import graphg from "../images/graphg.png"

function Data({ tempArray }) {
    //delete const values later and replace with values from arr
    const total = tempArray.length;
    const offers = tempArray.filter(el => el.status === "Received Offer").length;
    const interviews = offers + tempArray.filter(el => el.status === "Interviewing").length;

    // alert(offers + interviews)
    const wQuest = interviews + tempArray.filter(el => el.status === 'Received Questionnaire').length;

    //const offers = 0;

    return (
        <div className="data-cont">

            {/* <div className="temp">
                <span className="googblue">|</span><span className="googred">|</span>
                <span className="googyellow">|</span><span className="googreen">|</span>
            </div>
            <div className="ml"></div> */}

            <DataCard name="Applicants" number={total} image={graphb} />
            <DataCard name="Questionnaires" number={wQuest} image={graphy} />
            <DataCard name="Interviewing" number={interviews} image={graphp} />
            <DataCard name="Offers" number={offers} image={graphg} />
        </div>
    )
}

export default Data